import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/translationEN.json';

const resources = {
  en: {
    translation: {
      ...translationEN
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
  });

export default i18n;
